export default __webpack_public_path__ + "static/media/699.84777cc3.png";